import { ArrowRightIcon } from 'lucide-react'

import { cn } from 'src/shared/utils/cn'

import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '.'

interface SimpleDropdownProps {
  trigger: React.ReactNode
  items: {
    label: string
    onClick: () => void
  }[]
  onOpenChange?: (open: boolean) => void
}

export default function SimpleDropdown({ trigger, items, onOpenChange }: SimpleDropdownProps) {
  return (
    <DropdownMenu modal={false} onOpenChange={onOpenChange}>
      <DropdownMenuTrigger asChild className="focus-visible:outline-none">
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="flex w-[200px] flex-col gap-1 rounded-[12px] border-[0.5px] border-[#EFEFEF] bg-white p-2 shadow-sm"
      >
        {items.map((item) => (
          <DropdownMenuItem
            key={item.label}
            onClick={item.onClick}
            className={cn(
              'group flex cursor-pointer flex-row justify-between rounded-[8px] px-[12px] py-[8px] hover:bg-[#f8f7f5]',
              'text-[14px] leading-[1.85] text-muted',
            )}
          >
            <span className="group-hover:text-primary">{item.label}</span>
            <ArrowRightIcon className="size-4 text-primary opacity-0 transition-opacity duration-150 group-hover:opacity-100" />
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
